/**
 * @generated SignedSource<<136c609e3298eb7df06c6b7d5479f0c5>>
 * @relayHash 04e4b90dea049e8d68f96203c40536b4
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 04e4b90dea049e8d68f96203c40536b4

import { ConcreteRequest } from 'relay-runtime';
export type Ch_updatePatientCaveEntryInput = {
  message?: string | null;
  patientId: string;
};
export type useChPatientUpdateCaveMutation$variables = {
  input: Ch_updatePatientCaveEntryInput;
};
export type useChPatientUpdateCaveMutation$data = {
  readonly ch_updatePatientCaveEntry: {
    readonly ch_Patient: {
      readonly caveEntry: {
        readonly message: string | null;
        readonly updatedAt: string;
        readonly updatedBy: string;
      } | null;
    } | null;
  };
};
export type useChPatientUpdateCaveMutation = {
  response: useChPatientUpdateCaveMutation$data;
  variables: useChPatientUpdateCaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CaveEntry",
  "kind": "LinkedField",
  "name": "caveEntry",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChPatientUpdateCaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updatePatientCaveEntryPayload",
        "kind": "LinkedField",
        "name": "ch_updatePatientCaveEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_Patient",
            "kind": "LinkedField",
            "name": "ch_Patient",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChPatientUpdateCaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updatePatientCaveEntryPayload",
        "kind": "LinkedField",
        "name": "ch_updatePatientCaveEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_Patient",
            "kind": "LinkedField",
            "name": "ch_Patient",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "04e4b90dea049e8d68f96203c40536b4",
    "metadata": {},
    "name": "useChPatientUpdateCaveMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "48ba9d1ebf28a44297b6b279f3fc40c8";

export default node;
